// Helper functions to download scenario metadata as Excel files
import { downloadData } from "@nens/shared-utils";

import { API_BASE_URL, AuthMode } from "..";

interface ScenarioExportOptionsAll {
  mode: AuthMode;
}

interface ScenarioExportOptionsSome {
  scenarioIds: number[];
}

export async function downloadScenarioMetadata(
  fetchFunction: (path: string, options?: RequestInit) => Promise<Response>,
  options: ScenarioExportOptionsAll | ScenarioExportOptionsSome
) {
  const url = `${API_BASE_URL}/scenarios/export`;

  // If scenarioIds were chosen, send an array of scenario ids and mode null.
  // If ALL scenarios was chosen, send the mode as a parameter and no ids.
  const body =
    "mode" in options ? { id: [], mode: options.mode } : { id: options.scenarioIds, mode: null };

  const response = await fetchFunction(url, {
    method: "POST",
    body: JSON.stringify(body),
  });

  const data = await response.blob();

  const dateTimeString = new Date().toISOString().slice(0, 16).replace("T", "-").replace(":", "h");
  const filename = `${"mode" in options ? "all-" : ""}scenarios-metadata-${dateTimeString}.xlsx`;

  return downloadData(data, filename);
}
